import { OptionTitle } from "./OptionTitle"

export const PreservationCycleTestingOptions: Array<OptionTitle> = [
  { id: "ALREADY_DONE", title: "It's already done" },
  { id: "NEXT_TWO_MONTHS", title: "In the next 2 months" },
  { id: "NEXT_FOUR_MONTHS", title: "In the next 4 months" },
  { id: "NEXT_SIX_MONTHS", title: "In the next 6 months" },
  { id: "NOT_SURE", title: "I am not sure" }
]
